import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const approveCollaborationRequest = createAsyncThunk<
  void,
  { id: string; status: "approved" | "rejected" },
  { extra: Partial<Dependencies> }
>(
  "collaborationRequests/approveCollaborationRequest",
  async (data: { id: string; status: "approved" | "rejected" }, { extra: { teacherRepository } }) => {
    return teacherRepository!.approveCollaborationRequest(data);
  },
);

export const resetApproveCollaborationRequest = createAction("collaborationRequests/resetApproveCollaborationRequest");
